$('html').removeClass('no-js');

$(function () {
    /* global Modernizr:true */

    var _this = this,
        _body = $('body');
    /**
     * Initialize
     */
    _this.init = function()
    {
        $('a[rel="external"]').attr('target', '_blank');

        $('.hamburger').on('click', function() {
            $(this).parent().parent().parent().parent().toggleClass('open');
            $('.direct-contact').show();
            $(this).toggleClass('open');
        });
    };

    /**
     *  If body is not loaded, init
     */
    if (!_body.hasClass('loaded'))
    {
        _this.init();
    }
});